import React, { useCallback } from 'react';

import DialogView from 'components/Dialog';
import DialogBody from 'components/Dialog/components/DialogBody';

type Props = {
    fromPlayer?: boolean;
    title: string;
    description: string;
    descriptionNumberOfLines?: number;
    actionButtonTitle: string;
    handleActionButtonPress: () => void;
    errorCode?: string;
    actionButtonFillColor?: string;
    actionButtonTextStyle?: object;
    cancelButtonTitle?: string;
    handleCancelPress?: () => void;
    cancelButtonBordered?: boolean;
    actionButtonStyle?: false | object;
    cancelButtonTextStyle?: object;
    cancelButtonStyle?: false | object;
    style?: object;
    showDropdown?: () => void;
    titleTestID?: string;
    descriptionTestID?: string;
    actionButtonTestID?: string;
    closeButtonTestID?: string;
    errorCodeTestID?: string;
};
function RecordingsDialog({
    fromPlayer,
    title,
    errorCode,
    description,
    descriptionNumberOfLines,
    actionButtonTitle,
    handleActionButtonPress,
    actionButtonFillColor,
    actionButtonTextStyle,
    cancelButtonTitle,
    handleCancelPress,
    cancelButtonBordered,
    actionButtonStyle,
    cancelButtonStyle,
    cancelButtonTextStyle,
    style,
    showDropdown,
    titleTestID,
    descriptionTestID,
    actionButtonTestID,
    closeButtonTestID,
    errorCodeTestID,
}: Props) {
    const handleCancelButtonPress = useCallback(() => {
        handleCancelPress?.();
        showDropdown?.();
    }, [handleCancelPress, showDropdown]);

    if (fromPlayer) {
        return (
            <DialogBody
                title={title}
                description={description}
                descriptionNumberOfLines={descriptionNumberOfLines}
                errorCode={errorCode}
                actionButtonTitle={actionButtonTitle}
                handleActionButtonPress={handleActionButtonPress}
                actionButtonFillColor={actionButtonFillColor}
                actionButtonTextStyle={actionButtonTextStyle}
                cancelButtonTitle={cancelButtonTitle}
                handleCancelPress={handleCancelPress}
                cancelButtonBordered={cancelButtonBordered}
                actionButtonStyle={actionButtonStyle}
                cancelButtonTextStyle={cancelButtonTextStyle}
                cancelButtonStyle={cancelButtonStyle}
                style={style}
                fromPlayer
                titleTestID={titleTestID}
                descriptionTestID={descriptionTestID}
                actionButtonTestID={actionButtonTestID}
                closeButtonTestID={closeButtonTestID}
                errorCodeTestID={errorCodeTestID}
            />
        );
    }

    return (
        <DialogView
            title={title}
            description={description}
            descriptionNumberOfLines={descriptionNumberOfLines}
            errorCode={errorCode}
            actionButtonTitle={actionButtonTitle}
            actionButtonOnPress={handleActionButtonPress}
            actionButtonFillColor={actionButtonFillColor}
            actionButtonTextStyle={actionButtonTextStyle}
            cancelButtonTitle={cancelButtonTitle}
            cancelButtonOnPress={handleCancelButtonPress}
            cancelButtonBordered={cancelButtonBordered}
            actionButtonStyle={actionButtonStyle}
            cancelButtonStyle={cancelButtonStyle}
            style={style}
            fromPlayer={fromPlayer}
            titleTestID={titleTestID}
            descriptionTestID={descriptionTestID}
            actionButtonTestID={actionButtonTestID}
            closeButtonTestID={closeButtonTestID}
            errorCodeTestID={errorCodeTestID}
        />
    );
}

export default RecordingsDialog;
